var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height shrink",attrs:{"align":"center"}},[(_vm.resetButton)?_c('v-btn',{staticClass:"ml-1",attrs:{"icon":"","elevation":"2","title":_vm.resetTooltip},on:{"click":_vm.resetClick}},[_c('v-icon',[_vm._v(_vm._s(_vm.resetIcon))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }